import { put, takeEvery } from 'redux-saga/effects';
import { TRANSITION_START } from 'store/state/router/types';
import Cookie from 'js-cookie';
import { setCookieConsentModalAction } from 'store/state/app/actions';

export const COOKIE_USER_CONSENT_KEY = 'USER_SUBMIT_COOKIE';

function* cookiePageWatcher() {
  const token = Cookie.get(COOKIE_USER_CONSENT_KEY);
  yield put(setCookieConsentModalAction(!Boolean(token && token !== 'undefined' && token !== 'null')));
}

export function* cookieWatcher() {
  yield takeEvery(TRANSITION_START, cookiePageWatcher);
}
